import {
  allowedValuesRule,
  asWarning,
  pairedEditRule,
  type CellRule,
} from '../as400CellRuleKinds';
import {
  WARNING_CODES,
  WARNING_CODE_FIELDS,
  warningCodePlacement,
  type WarningCodeField,
} from './warningCodes';

export function warningCodeAllowlistRules(): CellRule[] {
  return WARNING_CODE_FIELDS.map((field) =>
    allowedValuesRule(field, WARNING_CODES, {
      blankAllowed: true,
      listAllowed: false,
    }),
  );
}

// GEN-2883: each warning code is explained by a product remark, so a changed
// code without its remark changed is worth a second look.
const WARNING_CODE_REMARKS: Readonly<Record<WarningCodeField, string>> = {
  IOWRN1: 'IOTH1E',
  IOWRN2: 'IOTH2E',
  IOWRN3: 'IOTH1F',
};

/** A warning, on the remark, when its warning code changes without it. */
export function warningCodeRemarkRules(): CellRule[] {
  return WARNING_CODE_FIELDS.map((field) =>
    asWarning(pairedEditRule(WARNING_CODE_REMARKS[field], field)),
  );
}

export function warningCodePlacementRules(): CellRule[] {
  return WARNING_CODE_FIELDS.flatMap((field) => [
    hardPlacementRule(field),
    asWarning(preferredPlacementRule(field)),
  ]);
}

function hardPlacementRule(field: WarningCodeField): CellRule {
  return {
    field,
    check(value) {
      const placement = warningCodePlacement(field, value);
      if (placement === null || !placement.required) return null;
      return {
        rule: 'warning-code-placement',
        slot: placement.slot,
        required: true,
      };
    },
  };
}

function preferredPlacementRule(field: WarningCodeField): CellRule {
  return {
    field,
    check(value) {
      const placement = warningCodePlacement(field, value);
      if (placement === null || placement.required) return null;
      return {
        rule: 'warning-code-placement',
        slot: placement.slot,
        required: false,
      };
    },
  };
}
